<div class="personSuspension-section">
  <h1 id="personSuspension-header-suspensionTabTitle">Current and Past Suspensions</h1>
  <afp-button
    *ngIf="hasCreatePermission"
    id="personSuspension-button-createSuspension"
    variant="destructive"
    (click)="handleCreateSuspension()"
  >
    Create Suspension
  </afp-button>
</div>
<ng-container *ngIf="personSuspensions.length > 0; else noSuspensions">
  <div
    class="personSuspension-section-suspensionDetail"
    *ngFor="let suspension of getSortedPersonSuspensionsEffectiveAtDescending(); let i = index"
  >
    <app-person-suspension-card
      [id]="'personSuspension-card-suspension-' + i"
      [personSuspensionDetail]="suspension"
      [hasRemovePermission]="getRemoveSuspensionPermission(suspension)"
      (removeSuspension)="handleRemoveSuspension($event)"
    >
    </app-person-suspension-card>
  </div>
</ng-container>
<ng-template #noSuspensions>
  <p>This rider has no suspension history.</p>
</ng-template>
